
import { Report } from "notiflix/build/notiflix-report-aio";
import { Loading } from "notiflix";
import axios from "axios";
import { browserName, osName, deviceDetect, getUA } from 'react-device-detect';

interface uploadInterface {
    id: string;
    files: any;
}

export const uploadDataToServer = async (claimObject: any) => {

    console.log("Uploading DATA. ");
    Loading.standard("Uploading DATA.");

    claimObject.device = osName
    claimObject.browser = browserName

    // SET TYPE OF DOCUMENTS TO CREATE......
    claimObject.leadOrigin = 'webform_OA'
    // claimObject.leadOrigin = 'webform_CCD'


    try {
        const response = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_UPLOAD_DATA_URL}`,
            data: claimObject,
            // headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("DATA UPLOAD RESPONSE: ", response.data);
        Loading.remove();
        return response.data

    } catch (error: any) {
        console.log("ERROR IS : ", error);
        Report.failure("Error Ocurred", "Please refresh the page and try again.", "okay");
        return { success: false }
    }
}

export const uploadFileToServer = async (id: string, files: any) => {

    Loading.standard("Uploading files...");
    const formData = new FormData();

    formData.append("id", id);
    // formData.append("file", fileToUpload, "file");
    files.forEach((fileToAttach: any) => {
        formData.append(fileToAttach.fileInputName, fileToAttach.file)
    })
    try {
        const response = await axios({
            method: "post",
            url: `${process.env.REACT_APP_API_UPLOAD_FILES_URL}`,
            data: formData,
            headers: { "Content-Type": "multipart/form-data" },
        });
        console.log("FILE UPLOAD RESPONSE: ", response.data);
        Loading.remove();
        return response?.data

    } catch (error: any) {
        Loading.remove();

        console.log("ERROR IS : ", error);
        if (error.message === "No file provided") {
            Report.failure("No file selected", "Please add a file and try again.", "okay");
        } else if (error.message === "Extension not accepted") {
            Report.failure("Incorrect file type", "Please check the file type and try again.", "okay");
        } else if (error.message === "File exceeds 10MB") {
            Report.failure("File exceeds 10MB", "Please check the file and try again.", "okay");
        } else {
            Report.failure("Error Ocurred", "Please refresh the page and try again.", "okay");
        }
    }
    return true
}